"use client";

import { useQuery } from "@tanstack/react-query";

export interface RelatedMarket {
  ticker: string;
  title: string;
  yesBid: number;
  yesAsk: number;
  lastPrice: number;
  image?: string;
}

export interface RelatedTab {
  label: string;
  subtitle?: string;
  eventTicker: string;
  markets: RelatedMarket[];
}

export interface RelatedGroup {
  type: string;
  label: string;
  scopes?: string[];
  highLevelFilter?: string;
  tabs: RelatedTab[];
}

export interface RelatedMarketsBundle {
  eventTicker: string;
  milestoneId?: string;
  groups: RelatedGroup[];
}

async function fetchRelated(eventTicker: string): Promise<RelatedMarketsBundle> {
  const res = await fetch(`/api/markets/kalshi/related/${encodeURIComponent(eventTicker)}`);
  if (!res.ok) return { eventTicker, groups: [] };
  return res.json();
}

/**
 * Resolves the bundle of sibling sport markets (Moneyline, Spread, Total,
 * 1H/2H lines, etc.) for a Kalshi event ticker. Use it to render PM-style
 * ML / SPR / TOT columns in the sports event hero.
 */
export function useKalshiRelatedMarkets(eventTicker: string | null | undefined) {
  return useQuery<RelatedMarketsBundle>({
    queryKey: ["kalshi", "related-markets", eventTicker],
    queryFn: () => fetchRelated(eventTicker as string),
    enabled: !!eventTicker,
    staleTime: 60_000,
    refetchInterval: 60_000,
    gcTime: 5 * 60 * 1000,
  });
}
